module.exports = __webpack_public_path__ + "static/img/banner.d51c476.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/img/banner.jpg
// module id = w9IP
// module chunks = 5